import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import 'babel-polyfill';
import { IProvider } from './interfaces';
import Schedule from './schedule';
import { } from 'googlemaps';
import { formatPhone, addDays, formatDate, addQueryParam, useSearchParams } from './util';
import Footer from './footer';
import FormProgress from './formprogress';
import { labels } from './labels';

function formatPipeSeparated(s: string) {
    if (s) {
        var u = s.split("|");
        var r = [];
        for (let i = 0; i < u.length; i++) {
            if (r.indexOf(i) < 0) {
                r.push(u[i]);
            }
        }
        return r.map(i => {
            return <>{i}<br /></>
        });
    } else {
        return "";
    }
}

const Provider = () => {
    const [provider, setProvider] = useState<IProvider>();
    const [next, setNext] = useState<string>();
    const [prev, setPrev] = useState<string>();
    const [map, setMap] = useState<google.maps.Map>();
    const [npi, deptid, date, reason, apptType, backToUrl, who] =
        useSearchParams(["npi", "deptid", "date", "reason", "apptType", "backto", "who"]);

    useEffect(() => {
        axios.get(`api/providers/${npi}?deptid=${deptid}&date=${date || ''}&apptType=${apptType || ''}&reason=${reason || ''}`)
            .then((result) => {
                const provider = result.data as IProvider;
                setProvider(provider);
                if (!map && document.getElementById("map")) {
                    if (!provider.location || !provider.location.latitude || (provider.location.latitude && provider.location.latitude === 0)) {
                        return;
                    }
                    const location = { lat: provider.location.latitude, lng: provider.location.longitude };
                    const newMap = new google.maps.Map(document.getElementById('map'), {
                        zoom: document.documentElement.clientWidth < 576 ? 13 : 14,
                        center: location
                        //styles: mapStyle,
                    });
                    new google.maps.Marker({
                        position: location,
                        map: newMap,
                        title: provider.firstName + ' ' + provider.lastName
                    });
                    setMap(newMap);
                }
                let d = date;
                if (!d) {
                    d = provider.availability.nextAvailable;
                }

                if (provider.availability && provider.availability.nextAvailable) {
                    d = d + "T12:00:00Z";
                    const nextDate = addDays(d, 5);
                    setNext(formatDate(nextDate));
                    const prevDate = addDays(d, -5);

                    const startDate = new Date(provider.availability.nextAvailable + "T12:00:00Z");
                    //const today = new Date(formatDate(new Date()) + "T12:00:00Z");

                    if (prevDate < startDate) {
                        setPrev("");
                    } else {
                        setPrev(formatDate(prevDate));
                    }
                }
            })
    }, [npi, date])

    function twoColumn(items) {
        return (<div className="text-auto-col">
            <p>
                {items.map(i => {
                    return <>{i}<br /></>
                })}
            </p>
        </div>)
    }

    function oneColumn(items) {
        return (<div>
            <p>
                {items.map(i => {
                    return <>{i}<br /></>
                })}
            </p>
        </div>)
    }

    return (<>
        <div className="container bg-white px-4 px-sm-5">
            {/*
            <div className="text-center pt-4 pb-4">
                <a href="./"><img className="d-block mx-auto" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px" }} /></a>
            </div>
            */}
            <div className="pt-4 row">
                <div className="col-lg-6">
                    <a href="./"><img className="d-block" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px" }} /></a>
                </div>
                <div className="col-lg-6">
                    <FormProgress currentStep={1} />
                </div>
            </div>
            <div className="mb-4">
                <Link to={{ pathname: backToUrl ? "/search": './', search: backToUrl }} className="btn btn-outline-primary">&larr; {backToUrl ? labels.provider.backTo : labels.search.newSearch}</Link>
            </div>
            {provider && (<>
                <div className="provider-container">
                    <div className="provider-main">
                        <div className="container px-0" id="hanging-icons">
                            <div className="row mb-3">
                                <div className="row g-4 row-cols-1 bio-headshot-wrap">

                                    <div className="col d-flex align-items-start">
                                        <div className="icon-square bg-light text-dark flex-shrink-0 me-3 px-2 mr-3">
                                            <img className="py-1" src={(window as any).PHOTO_URL + (provider.photo ? provider.photo : (provider.gender === "M" ? "m00000000.jpg" : "f00000000.jpg"))} width="150" alt={provider.firstName + " " + provider.lastName} />
                                        </div>

                                        <div>
                                            <h3>{provider.firstName} {provider.lastName}{provider.academicTitle && (", " + provider.academicTitle)}</h3>
                                            {/*<p>{provider.certification && provider.certification.split("|").join(", ")}</p>*/}
                                            <p><div className="mb-1">
                                                {provider.clinic}<br />
                                                {provider.clinicOldName && <span style={{ fontSize: "80%" }}><em>formerly {provider.clinicOldName}</em><br /></span>}
                                            </div>
                                                {provider.virtualist ? <span style={{ display: "inline-block", verticalAlign: "middle", color: "var(--primary-color)", fontWeight: "bold", fontSize: "1.2rem" }}>Virtual Primary Care Only</span> :
                                                    <>{provider.address1} < br />
                                                        {provider.city}, {provider.state} {provider.zipCode}</>
                                                }</p>
                                            <p>
                                                {labels.provider.phone}: <a href={"tel:" + formatPhone(provider.phone)}>{formatPhone(provider.phone)}</a>< br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="provider-schedule px-4">                        
                        <Schedule npi={provider.npi} ageCutoff={provider.ageCutoff} clinic={provider.clinic} phone={formatPhone(provider.phone)} availability={provider.availability} next={next} prev={prev} deptid={deptid} backToUrl={backToUrl} apptType={apptType} reason={reason} who={who} />
                    </div>

                    <div className="provider-more">

                        <h4>{labels.provider.generalInfo}</h4>

                        <h5>{labels.provider.boardCertifications}</h5>
                        <p>{formatPipeSeparated(provider.certification)}</p>

                        {provider.title &&
                            <>
                                <h5>{labels.provider.academicTitles}</h5>
                                <p>{formatPipeSeparated(provider.title)}</p>
                            </>
                        }
                        {provider.language &&
                            <><h5>{labels.provider.languagesSpoken}</h5>
                                <p>{formatPipeSeparated(provider.language)}</p></>
                        }
                        <h5>{labels.provider.gender}</h5>
                        <p>{provider.gender === "M" ? labels.provider.genders.male : provider.gender === "F" ? labels.provider.genders.female : labels.provider.genders.other}</p>

                        {provider.education && <>
                            <h4>{labels.provider.education}</h4>
                            <div style={{ marginBottom: "2em" }}>
                            {provider.education.split("|").map(e => {
                                return <h6>{e.split(": ")[0]}: <span style={{ fontWeight: "normal" }}>{e.split(": ")[1]}</span></h6>
                            })}
                            </div>
                        </>
                        }
                        
                        {provider.clinicalInterests && <>
                            <h4>{labels.provider.clinicalInterests}</h4>
                            {oneColumn(provider.clinicalInterests.split("|").filter((x, i, a) => a.indexOf(x) === i))}
                        </>}

                        {provider.otherServices && <>
                            <h4>{labels.provider.otherServices}</h4>
                            {oneColumn(provider.otherServices.split("|"))}
                        </>}

                    </div>

                    <div className="provider-insurance">
                        <h4>{labels.provider.insuranceAccepted}</h4>
                        {twoColumn(provider.insurance.split("|").sort())}                        
                    </div>
                    {!provider.virtualist &&
                        <div className="provider-map">
                            <div id="map" className="map map-wide"></div>
                        </div>}
                </div>
                <br style={{ clear: "both" }} />
            </>)}
        </div>
        <Footer />
    </>);
}

export default Provider;